<template>
<div>
  <el-dialog :title="formData.id?'编辑账号':'新增账号'" :visible.sync="visible" width="750px" class="my-dialog-template" :close-on-click-modal="false">
    <el-form :inline="true" :model="formData" ref='formRef' class="my-form-template" label-width="90px" v-loading="loading">
      <el-form-item label="登录账号" prop="account" class="less" :rules="$tools.formRule.required('请输入')">
        <el-input v-model.trim="formData.account" placeholder="请输入" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="登录名称" prop="name" class="less" :rules="$tools.formRule.required('请输入')">
        <el-input v-model.trim="formData.name" placeholder="请输入" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" class="less" v-if="showPassBtn">
        <el-button class="org-btn small" v-if="showPassBtn" @click="formData.password='';showPassBtn=false">修改密码</el-button>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" class="password-box" :class="formData.id?'full':'less'" v-else 
        :rules="[$tools.formRule.required('请输入'),$tools.formRule.count('请输入8-16位密码',[8,16])]" >
        <el-input :type="showPass ? 'text' : 'password'" v-model.trim="formData.password" placeholder="请输入" style="width:240px">
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-hide.png" @click="showPass = !showPass" v-if="!showPass"/>
          <img slot="suffix" class="show-pass" src="@static/images/orgManage/eye-show.png" @click="showPass = !showPass" v-else/>
        </el-input>
        <el-button class="org-btn small" v-if="formData.id" @click="formData.password=password;showPassBtn=true" 
          style="margin-left:20px;vertical-align: middle;">隐藏密码</el-button>
        <span class="info-text">密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</span>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" class="less" :rules="[$tools.formRule.required('请输入'),$tools.formRule.tel()]">
        <el-input v-model.trim="formData.mobile" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="roleId" class="less" :rules="$tools.formRule.required('请选择')" v-if="!formData.id">
        <el-select v-model.trim="formData.roleId" placeholder="请选择" filterable :disabled="formData.useStatus=='0'">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in roleList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="useStatus" class="less" :rules="$tools.formRule.required('请选择')">
        <el-radio-group v-model.trim="formData.useStatus">
          <el-radio label="0">禁用</el-radio>
          <el-radio label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button class="org-btn" plain @click="visible=false">取消</el-button>
      <el-button @click="save()">确定</el-button>
    </div>
  </el-dialog>
</div>
  
</template>
<script>
export default {
  data: () => ({
    visible: false,
    loading: false,
    showPass:false,
    showPassBtn:false,
    formData:{},
    roleList:[],
    password:"",
  }),
  components: {},
  methods: {
    async open(data={}) {
      const loading = this.$notice.loading();
      await this.getRoleList();//获取所有权限菜单
      if(data.id){
        await this.getDetailData(data.id);//获取所有权限菜单
        this.showPassBtn = true;
      }else{
        this.formData = {useStatus:"1"}
        this.showPassBtn = false;
      }
      this.visible = true
      this.$refs.formRef&&this.$refs.formRef.clearValidate()
      loading.close();
    },
    // 详情数据
    getDetailData(id){
      return this.$http({
        url:'/master/mechanUser/read/detail',
        type:'GET',
        params:{id},
      }).then(res=>{
        this.password = res.data.password;
        this.formData = res.data;
      })
    },
    // 角色列表
    getRoleList(){
      return this.$http({
        url:'/master/mechanRole/list',
        type:'PUT',
        params:{
          pageNum:1,
          pageSize:99,
        },
      }).then(res=>{
        this.roleList = res.data;
      })
    },
    save(isNext) {
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          this.$http({
            url:'/master/mechanUser/update',
            type:'POST',
            params:this.formData,
          }).then(res=>{
            this.$message.success("保存成功");
            this.$emit("reload")
            this.visible = false
          })
          
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template {
  /deep/ {
    .el-form {
      align-items: flex-start;
    }
    .password-box {
      .info-text {
        font-size: 12px;
        color: #888;
        position: absolute;
        left: -90px;
        width: 430px;
        top: 32px;
      }
      .el-form-item__content {
        padding-bottom: 25px;
      }
    }
  }
}
</style>